module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qabdo4-159cc1a846e233cd60b70b1a8fb13002.jpg";